/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './OptionButton.style';

import BaseButton from 'src/shared/ui/component/button/BaseButton';
import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

import type { Button } from '@e180/ui/lib/component/button/type/buttonTypes';

type Props = Button & {
  isFetching: boolean,
  withSuccess?: boolean,
};

const useStyles = createUseStyles(styles);

const OptionButton = (props: Props): React.Node => {
  const { layoutClass, isFetching, withSuccess, isDisabled } = props;

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor, darkAccentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor, darkAccentColor });

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-isDisabled']]: isDisabled,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <BaseButton
      className={rootClasses}
      isFetching={isFetching}
      withSuccess={withSuccess}
      // $FlowIssue
      {...props}
    />
  );
};

export default compose(React.memo)(OptionButton);
